import { setRoomEditData, voteRoomDiscussionPoll } from '@/actions/room';
import { Checkbox, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

const { Text } = Typography;

const Poll = ({ each }) => {
  const dispatch = useDispatch();

  const isRoomMember = useSelector(
    (state: any) => state?.roomReducer?.roomDetail?.data?.is_member
  );

  const handleVotePoll = (id, discussionId) => {
    dispatch(
      setRoomEditData({
        name: 'poll',
        key: 'commentId',
        value: id,
      })
    );
    dispatch(
      setRoomEditData({
        name: 'poll',
        key: 'discussionId',
        value: discussionId,
      })
    );
    dispatch(voteRoomDiscussionPoll({ answerId: id }));
  };

  return (
    <div className={`${isRoomMember && 'pb-2'} px-3`}>
      {each?.poll?.map((poll, index) => (
        <div
          key={index}
          className="d-flex align-items-center my-2"
          style={{ height: '50px' }}
        >
          <div
            placeholder={`Poll Option ${index + 1}`}
            style={{
              flex: 1,
              borderColor: '#d3d3d3',
              borderRadius: '10px',
              borderWidth: '1px',
              borderStyle: 'ridge',
            }}
            className="h-100 position-relative d-flex align-items-center justify-content-between "
          >
            <div
              style={{
                backgroundColor: '#739fd1',
                borderRadius: '10px',
                display: 'flex',
                width: poll?.vote_count ? poll.vote_count : '0',
              }}
              className="h-100 "
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center position-relative ">
                  {!poll?.voted_by_user && (
                    <Checkbox
                      style={{
                        fontSize: '22px',
                      }}
                      className="position-absolute ml-3"
                      onClick={() => handleVotePoll(poll?.id, each?.id)}
                    />
                  )}
                  <Text
                    style={{
                      fontWeight: '500',
                      whiteSpace: 'nowrap',
                    }}
                    className={`position-absolute ${
                      poll?.voted_by_user ? 'ml-3' : 'ml-5'
                    }`}
                  >
                    {poll?.answer}
                  </Text>
                </div>
              </div>
            </div>
            <Text className="pr-3 position-absolute" style={{ right: '0' }}>
              {poll.vote_count}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Poll;
